import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import SectionContainer from './components/section/SectionContainer'
import LPContainer from './LPContainer'

const TeamSection: FCC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation()
  return (
    <SectionContainer
      title="lp:team_section:title"
      tagLabel="lp:team_section:tag"
      tagColor="bg-purple-100 text-purple-800"
      className="pb-5 mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0">
      <LPContainer className="mt-6 space-y-10 px-0 tablet:px-4">
        <div className="mt-8 tablet:mt-12 flex flex-col gap-3 tablet:gap-5">
          <div className="flex gap-5 flex-col tablet:flex-row">
            <div className="max-w-[700px] bg-gray-100 border border-transparent rounded-xl pt-6">
              <div className="font-medium text-lg text-gray-900 text-center">
                {t('lp:team_section:manage_candidate_profiles')}
              </div>
              <div className="my-1 text-base text-center text-gray-700 px-8">
                {t('lp:team_section:manage_candidate_des')}
              </div>
              <Image
                src={'/img/feature/lp/manage_group_small.png'}
                alt="manage_group_small"
                width={367}
                height={314}
                className="mt-8 desktop:hidden"
                quality={100}
              />
              <img
                src={'/img/feature/lp/manage_group.png'}
                alt="manage_group"
                className="mt-8 h-auto w-full hidden desktop:block"
              />
            </div>
            <div className="bg-gray-100 border border-transparent rounded-xl pt-6">
              <div className="font-medium text-lg text-gray-900 text-center">
                {t('lp:team_section:integration')}
              </div>
              <div className="my-1 text-base text-center text-gray-700 px-8">
                {t('lp:team_section:integration_des')}
              </div>
              <div>
                <img
                  src={'/img/feature/lp/integrate.png'}
                  alt="integrate"
                  className="mt-8 w-full rounded-lg"
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col tablet:flex-row gap-[21px]">
            <div className="max-w-[700px] bg-gray-100 border border-transparent rounded-xl pt-6">
              <div className="font-medium text-lg text-gray-900 text-center">
                {t('lp:team_section:user_permissions')}
              </div>
              <div className="my-1 text-base text-center text-gray-700 px-8">
                {t('lp:team_section:user_permissions_des')}
              </div>
              <Image
                src={'/img/feature/lp/user_permission_small.png'}
                alt="user_permission_small"
                width={343}
                height={306}
                className="mt-8 desktop:hidden"
                quality={100}
              />
              <img
                src={'/img/feature/lp/user_permission.png'}
                alt="user_permission"
                className=" mt-8 h-auto w-full hidden desktop:block"
              />
            </div>
            <div className="bg-gray-100 border border-transparent rounded-xl pt-6">
              <div className="font-medium text-lg text-gray-900 text-center">
                {t('lp:team_section:interview_scheduling')}
              </div>
              <div className="my-1 text-base text-center text-gray-700 px-8">
                {t('lp:team_section:interview_scheduling_des')}
              </div>
              <div>
                <Image
                  src={'/img/feature/lp/interview_small.png'}
                  alt="interview_small"
                  width={343}
                  height={328}
                  className="mt-8 desktop:hidden"
                  quality={100}
                />
                <img
                  src={'/img/feature/lp/interview.png'}
                  alt="interview"
                  className="mt-8 w-full rounded-lg px-9 hidden desktop:block"
                />
              </div>
            </div>
          </div>
        </div>
      </LPContainer>
    </SectionContainer>
  )
}

export default TeamSection
